import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExtraRoutingModule } from './extra-routing.module';
import { TranslateComponent } from './translate/translate.component';
import { LoginComponent } from './login/login.component';
import { VideoComponent } from './video/video.component';
import { VideologinComponent } from './video/videologin/videologin.component';
import { VerticalComponent } from '../vertical/vertical.component';
import { SharedModule } from '../module/shared/shared.module';
import { TranslateGuard } from '../translate.guard';
import { VideoGuard } from '../video.guard';
import {FilterTextPipe} from '../pipe/filter-text.pipe';

@NgModule({
  declarations: [
    TranslateComponent,
    LoginComponent,
    VideoComponent,
    VideologinComponent,
    VerticalComponent,
    FilterTextPipe
  ],
  providers: [TranslateGuard, VideoGuard],
  imports: [CommonModule, SharedModule, ExtraRoutingModule],
})
export class ExtraModule {}
